<template>
<v-dialog
  v-model="isPreviewWinVisible"
  width="80%"
  persistent
>
  <v-img :src="cardio.obj_url">

    <template v-slot:placeholder>
      <v-progress-circular
        indeterminate
        color="grey lighten-5"
      />
    </template>
    <v-spacer />

    <v-btn icon @click="closePreviewWin" fixed>
      <v-icon>mdi-close</v-icon>
    </v-btn>

  </v-img>
</v-dialog>
</template>



<script>
// import putDoc from '../api/mindsync';

export default {
  name: 'PreviewWindow',
  // props: ['item'],
  data: () => ({
    dialog: false,
    new_note: '',
  }),
  computed: {
    isPreviewWinVisible: {
      get() {
        return this.$store.getters['ui/isPreviewWinVisible'];
      },
      set(value) {
        console.log(`isPreviewWinVisible new value is: ${value}`)
        // this.$store.dispatch('ui/closeEditForm')
      }
    },
    activeDoc () {
      return this.$store.getters['ui/activeDoc']
    },
    cardio() {
      console.log('-> calling cardio from PreviewWindow')
      if (!this.activeDoc) {
        console.log('|| missing activeDoc')
        return {}
      }
      var ret = this.$store.getters.included(this.activeDoc)
      return ret
    }
  },
  // watch: {
  //   activeDoc (new_val, old_val) {
  //     console.log(`WA ${new_val} <- ${old_val}`)
  //   },
  // },
  methods: {
    closePreviewWin() {
      console.log('=> calling closePreviewWin');
      this.$store.dispatch('ui/closePreviewWin'); // closes the window
    },
  }
}

</script>
